<rotec-pages-v2>
  <a (click)="returnToList()" [class.pages-active-link]="isActive">
    <h3 translate>Rotor Types</h3>
    <span>{{ noOfRotorTypes$ | async }}</span>
  </a>
</rotec-pages-v2>
